import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CountryDepartment } from '@app/models/country-department';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
	providedIn: 'root'
})
export class CountryDepartmentService {
	constructor(private http: HttpClient) { }

	get(FollowId, dataFilter?) {
		//This CountryId is for Business
		return this.http.get<CountryDepartment[]>(
			`${API}country_departments?${FollowId ? 'FollowId=' + FollowId : ''}${dataFilter.CountryId ? '&CountryId=' + dataFilter.CountryId : ''
			}${dataFilter.businessUnit
				? '&businessUnit=' + dataFilter.businessUnit
				: ''
			}`
		);
	}

	getByProducts(FollowId, dataFilter?) {
		//get only the departments that are needed to view
		//This CountryId is for Business
		return this.http.get<CountryDepartment[]>(
			`${API}country_departments/country_departments?FollowId=${FollowId}${dataFilter.CountryId ? '&CountryId=' + dataFilter.CountryId : ''
			}${dataFilter.businessUnit
				? '&businessUnit=' + dataFilter.businessUnit
				: ''
			}${dataFilter.DestinationCenterId
				? '&DestinationCenterId=' + dataFilter.DestinationCenterId
				: ''
			}`
		);
	}

	search(conditions, FollowId) {
		const data = [...conditions, { key: 'FollowId', value: FollowId }];

		return this.http.post<any>(
			`${API}country_departments/hierarchyCountrySearch`,
			data
		);
	}

	create(data) {
		return this.http.post<CountryDepartment>(`${API}country_departments`, data);
	}

	update(id, data) {
		return this.http.put<CountryDepartment>(`${API}country_departments/${id}`, data);
	}

	destroySingle(CountryDepartmentId) {
		return this.http.delete<any>(`${API}country_departments/${CountryDepartmentId}`);
	}

	getById(FollowId, dataFilter?) {
		//This CountryId is for Business
		return this.http.get<CountryDepartment[]>(
			`${API}country_departments/country_one_department?${FollowId ? 'FollowId=' + FollowId : ''}${dataFilter.CountryId ? '&CountryId=' + dataFilter.CountryId : ''
			}${dataFilter.businessUnit
				? '&businessUnit=' + dataFilter.businessUnit
				: ''
			}${dataFilter.CategoryId
				? '&CategoryId= ' + dataFilter.CategoryId
				: ''}`
		);
	}

	updateHierarchy(){
		return this.http.get<any>(`${API}country_departments/validateHierarchy`);
	}
}
